export default __webpack_public_path__ + "static/media/philadelphia.e27ca60b.png";